// ------------------------------------------------------------------
// Регулярки для пабликов (каналы, группы, аккаунты, join-ссылки)
// ------------------------------------------------------------------
const PUBLIC_PATTERNS: Record<'telegram' | 'max', RegExp> = {
  // Telegram:
  // - t.me/username (или telegram.me/username)
  // - t.me/joinchat/<hash>
  // - t.me/+<hash> (пригласительная ссылка)
  telegram: /^(https?:\/\/)?(t|telegram)\.(me|dog)\/(joinchat\/[-_\w\d]+|[+\-_\w\d]+)$/i,

  // MAX:
  // - https://max.ru/join/<hash>   (join-ссылка)
  // - https://max.ru/-<id>         (канал по числовому ID, например -123)
  // - https://max.ru/<slug>        (slug: буквы/цифры с подчёркиваниями, например abc_def_123)
  max: /^(https?:\/\/)?max\.ru\/(join\/[A-Za-z0-9_-]+|-\d+|[a-z\d]+(?:_[a-z\d]+)*)$/i
};

// ------------------------------------------------------------------
// Регулярки для сообщений (постов)
// ------------------------------------------------------------------
const MESSAGE_PATTERNS: Record<'telegram' | 'max', RegExp> = {
  // Telegram:
  // - t.me/username/<post_id> (пост в канале)
  // - t.me/c/<chat_id>/<post_id> (пост в супергруппе/канале по ID)
  telegram: /^(https?:\/\/)?(t|telegram)\.(me|dog)\/(?:c\/\d+\/|\w+\/)\d+(?:\?.*)?$/i,

  // MAX — несколько поддерживаемых форматов:
  // 1. max.ru/<channel_name>/<message_id>   (пример: max.ru/dvach/AZ913KR4cYU)
  // 2. max.ru/c/<chat_id>/<message_id>     (пример: max.ru/c/-69700663115999/AZ8XTrgUFF0) [reference:0]
  // 3. max.ru/channel/<channel_id>/<message_id> (возможный вариант)
  // 4. max.ru/post/<message_id>            (если есть такой формат)
  //
  // ВАЖНО: флаг 'i' в конце убран, чтобы учитывать регистр букв в message_id.
  max: /^(https?:\/\/)?(www\.)?max\.ru\/(?:c\/[^/]+\/|[^/]+\/|[^/]+\/post\/)?[A-Za-z0-9_-]+$/,
};

// ------------------------------------------------------------------
// Функция-детектор пабликов
// ------------------------------------------------------------------
export function detectPublicLink(url: string): 'telegram' | 'max' | null {
  if (!url) return null;
  const normalized = url.trim().toLowerCase();
  for (const [platform, regex] of Object.entries(PUBLIC_PATTERNS)) {
    if (regex.test(normalized)) {
      return platform as 'telegram' | 'max';
    }
  }
  return null;
}

// ------------------------------------------------------------------
// Функция-детектор сообщений
// ------------------------------------------------------------------
export function detectMessageLink(url: string): 'telegram' | 'max' | null {
  if (!url) return null;
  const normalized = url.trim(); // toLowerCase() УБРАН, чтобы сохранить регистр!
  for (const [platform, regex] of Object.entries(MESSAGE_PATTERNS)) {
    if (regex.test(normalized)) {
      return platform as 'telegram' | 'max';
    }
  }
  return null;
}